import { useQuery } from "@tanstack/react-query";
import { listCustomerContext } from "./api";
import { customerPageKeys, getPrimaryContact } from "./tool-hubs-api";

/**
 * The customer's contacts and which one is primary (ADR-0088). Contacts live in the customer's
 * isolated context, so both reads wait until that context is ready.
 */
export function usePrimaryContact(organizationId: string, enabled: boolean) {
  const context = useQuery({
    queryKey: customerPageKeys.context(organizationId),
    queryFn: () => listCustomerContext(organizationId),
    enabled,
  });
  const pointer = useQuery({
    queryKey: customerPageKeys.primaryContact(organizationId),
    queryFn: () => getPrimaryContact(organizationId),
    enabled,
  });
  const people = context.data?.people ?? [];
  const personId = pointer.data?.personId ?? null;
  return {
    context,
    people,
    primary: people.find((person) => person.id === personId) ?? null,
    loading: enabled && (context.isPending || pointer.isPending),
  };
}
